import { t } from "i18next";
import React from "react";
import { ChevronRightDisable, ChevronRightRed } from "../../../../../../asset";
import { Col, Row, Skeleton } from "antd";
import useDetailTripPlan from "../detail-trip-plan.hooks";
import DefaultPagination from "../../../../../../component/pagination/default-pagination";

const TabTrip = () => {
  const {
    data,
    listDA,
    pageDA,
    limitDA,
    initiateDA,
    isSkeletonListDA,
    _toDetailDA,
    _handlePagination,
    _changeRowPerPage,
  } = useDetailTripPlan();

  return (
    <div className="flex">
      <div className="w-[500px] mb-[24px]">
        {/* Tab Title */}
        <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
          {t("Trip Detail")}
        </h3>

        {/* Tab Content */}
        <div className="flex">
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Trip Plan ID")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {data?.id ? data?.id : "-"}
              </h4>
            </div>
          </div>
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Plan Name")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {data?.trip_plan_name ? data?.trip_plan_name : "-"}
              </h4>
            </div>
          </div>
        </div>

        {/* List Delivery Associate */}
        <div className="w-[75rem] mb-[10px]">
          {isSkeletonListDA ? (
            <Skeleton active />
          ) : (
            listDA &&
            listDA.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${
                    item.delivery_associate_name.includes("- 0 Order")
                      ? "bg-[#EEEEEE]"
                      : "bg-[#F9F9F9]"
                  } h-[5rem] rounded-[4px] flex flex-col justify-center shadow-md mb-5`}
                >
                  <Row>
                    <Col span={23}>
                      <p className="font-roboto font-medium text-2xl text-[#424242] ml-[20px]">{`${item?.delivery_associate_name}`}</p>
                    </Col>
                    <Col span={1}>
                      <div>
                        <img
                          className={
                            item.delivery_associate_name.includes("- 0 Order")
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          }
                          src={
                            item.delivery_associate_name.includes("- 0 Order")
                              ? ChevronRightDisable
                              : ChevronRightRed
                          }
                          alt="chevron-right"
                          onClick={
                            item.delivery_associate_name.includes("- 0 Order")
                              ? null
                              : () => {
                                  _toDetailDA(item);
                                }
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })
          )}

          <DefaultPagination
            idLimit="ddlrowsperpagedeliveryassociatetripplanning"
            title={t("COMMON:ROW_PAGE")}
            current={pageDA}
            handlePaging={(evt) => {
              _handlePagination(evt, "da");
            }}
            initiate={initiateDA}
            selectedRowPage={limitDA}
            changeRowPerPage={(evt) => {
              _changeRowPerPage(evt, "da");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TabTrip;
